<template>
  <div>
  	<div class="error" v-if="error">{{ error }}</div>
  	<div v-if="submitted">
  		<h3>Thank you, your application has been submitted</h3>
  	</div>
  	<div v-else>
  		<b-form-group
			id="input-group-1"
			label="Name: *"
			label-for="input-1"
		>	
	        <b-form-input
		          id="input-1"
		          v-model="form.name"
		          type="text"
		          required
		          placeholder="Tell us your name"
		          :class="(hasError['name']) ? 'errorfield' : ''"
	        ></b-form-input>
      	</b-form-group>
      	<!-- Check on blur to make sure email hasn't already been registered -->
		<b-form-group
			id="input-group-2"
			label="Email: *"
			label-for="input-2"
		>
	        <b-form-input
		          id="input-2"
		          v-model="form.email"
		          type="email"
		          required
		          placeholder="Enter email"
		          :class="(hasError['email']) ? 'errorfield' : ''"
	        ></b-form-input>
      	</b-form-group>
      	<b-form-group
			id="input-group-3"
			label="Mobile Number: *"
			label-for="input-3"
		>
	        <vue-tel-input 
		        defaultCountry="NG" 
		        placeholder="Mobile Number"
		        :validCharactersOnly="trueVar" 
		        :preferredCountries="preferredCountries" 
		        :class="(hasError['phone']) ? 'errorfield' : ''"
		       	@input="onInput"
		       >
		    </vue-tel-input>
      	</b-form-group>
      	<div class="error" v-if="uploadError && uploadError['coverletter']  != ''"><i>{{ uploadError['coverletter'] }}</i></div>
      	<b-form-group
			id="input-group-8"
			label="Upload Cover Letter: *"
			label-for="input-4"
		>
	       <b-form-file
		      v-model="form.coverletter"
		      placeholder="Choose a file or drop it here..."
		      drop-placeholder="Drop file here..."
		      @change="addFile($event, 'coverletter')"
		      :class="(hasError['coverletter']) ? 'errorfield' : ''"
		    ></b-form-file>
      	</b-form-group>

      	<div class="error" v-if="uploadError && uploadError['cv'] != ''"><i>{{ uploadError['cv'] }}</i></div>
      	<b-form-group
			id="input-group-4"
			label="Upload CV: *"
			label-for="input-4"
		>
	       <b-form-file
		      v-model="form.cv"
		      placeholder="Choose a file or drop it here..."
		      drop-placeholder="Drop file here..."
		      @change="addFile($event, 'cv')"
		      :class="(hasError['cv']) ? 'errorfield' : ''"
		    ></b-form-file>
      	</b-form-group>
      	<p>&nbsp;</p>
      	<p>&nbsp;</p>
      	<b-button @click="submitApplication()" variant="secondary" class="btn-lg btn-block">Apply &raquo;</b-button>
      </div>
  </div>
</template>
<script>
	import { VueTelInput } from 'vue-tel-input'

	export default {
	  name: "applymodal",
	  components: {
	    VueTelInput,
	  },
	  data: function(){
	  	return {
	  		form: {},	
	  		hasError: {},
	  		trueVar: true,
        	preferredCountries: ['NG'],  
        	error: null,
        	errorfield: '',
        	uploadError: {
        		cv: '',
        		coverletter: ''
        	},
        	submitted: false	

	  	}
	  },
	  methods: {
	  	onInput(formattedNumber, { number, isValid }) {
	      // this.phone1.number = number;
	      // this.phone1.isValid = isValid;
	      // this.phone1.country = country && country.name;
	        if (isValid){
	          this.form.phone = number
	        } else {
	          this.form.phone = ''
	        }
	    },
	    validateEmail(email) {
	        var re = /\S+@\S+\.\S+/;
	        return re.test(email);
	    },
	    submitApplication(){
	    	this.error = null
	  		this.hasError = {}
	  				
			if (this.form.email == '' || !this.validateEmail(this.form.email)){
				this.hasError['email'] = true
			}
			if (this.form.name == '' || !this.form.name){
				this.hasError['name'] = true
			}
			if (this.form.phone == '' || !this.form.phone){
				this.hasError['phone'] = true
			}
			if (this.form.cv == '' || !this.form.cv){
				this.hasError['cv'] = true
			}
			if (this.form.coverletter == '' || !this.form.coverletter){
				this.hasError['coverletter'] = true
			}
			if (Object.keys(this.hasError).length > 0){
				this.error = "Please fill in all required fields"
				return false
			}

			this.submitted = true

		

	    },
	    addFile(event, key){
	    	console.log('key', key)
	  		this.uploadError[key] = ''
	        var allowedFiles = ["pdf", "doc", "docx"]
	        var fileExtension = event.target.files[0].name.split('.').pop().toLowerCase()
	        this.form[key] = null
	        
	        if (allowedFiles.indexOf(fileExtension) < 0){
	          this.uploadError[key] = 'Your file type is not allowed, please upload a document (doc, docx, or pdf)'  
	          console.log(this.uploadError[key])
	        } else if (event.target.files[0].size > 1048576){
	          this.uploadError[key] = 'Your logo file size is too large, please upload a document smaller than 1MB'
	        } else {
	          this.form[key] = event.target.files[0]
	        }
	        // this.error = this.uploadError[key]
	    },
	  
	  },
	  mounted(){
	  	
	  	
	  }
	};
</script>
<style scoped>
	.error{
		padding:10px;
		color:#CC0000;
		border:1px dotted #CC0000;
		border-radius:5px;
		margin-bottom:15px;
	}

	.errorfield{
		border:1px solid #CC0000 !important;
	}
</style>